// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"styles_errorContainer__3BqDu","errorSelector":"styles_errorSelector__3ct1n"};